module.exports = __webpack_public_path__ + "img/quali 1.29163d5.png";